import React from 'react';
import { View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { openCaseInfo } from '../../../cases/actions';
import { sendInvitations } from '../../../invite/actions';
import { setSelectedConsult } from '../../../referrals/actions';

import { OPComponent, I18n, Utils, Navigation, HeaderItem } from '../../../components';

import CaseSearchEmployer from '../../case_search_employer';

import ListRow, {
  GROUP_STYLE,
  RANK_STYLE,
  DEPLOY_STYLE,
  PATIENT_TYPE_STYLE,
  PROCEDURES_STYLE,
  NAME_STYLE,
} from './list_row';

class PeopleListAirforce extends OPComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggleToRefreshSearch: false,
    };
  }

  _handleConsultOpen = (consult) => {
    const title = `${consult.is_urgent ? 'Urgent ' : ''}Consult Request`;
    Navigation.showModal({
      screen: 'ConsultInfo',
      title,
      passProps: {
        consult,
        title,
        disabled: true,
      },
    });
    this.props.actions.setSelectedConsult(consult.consult_request_id);
  };

  renderItem = (itemRow) => {
    return (
      <ListRow
        data={itemRow.item.item}
        index={itemRow.index}
        handleResidentTap={this.handleResidentTap}
        handleTaskingIdTap={this.handleTaskingIdTap}
        handleGroupTap={this.handleGroupTap}
        onResendInvitePress={this._handleResendInvitePress}
        onConsultOpen={this._handleConsultOpen}
      />
    );
  };

  _handleResendInvitePress = (data) => {
    const confirmationOpts = {
      title: 'Resend Invite?',
      description: `The user has been added to the system but they haven't accepted the invite to join the app. Resend the invite?`,
      confirm: 'Yes, Resend',
      onConfirmed: () => {
        this._resendInvite(data);
        this._closeConfirmation();
      },
      onCancelled: this._closeConfirmation,
    };

    this.setState({ confirmationOpts });
  };

  _closeConfirmation = () => {
    this.setState({ confirmationOpts: null });
  };

  _resendInvite = (caseInfo) => {
    const email = caseInfo.patient.email;
    const submitArray = [{ inviteeEmail: email, inviteePhone: null }];
    const message = '';
    const username = caseInfo.patient.fullName;

    this.props.actions.sendInvitations(caseInfo.caseId, submitArray, message, {
      username,
      email,
    });
  };

  handleResidentTap = (caseId) => {
    Utils.trackEvent('Action', 'Select', 'Open Resident', caseId);

    this.props.actions.openCaseInfo(caseId);
    Navigation.openScreen(
      {
        screen: 'CaseInfo',
        passProps: {
          onCloseScreen: this.handleModalClosed,
        },
      },
      this.props.componentId,
      true
    );
  };

  handleTaskingIdTap = (taskingId) => {
    Utils.trackEvent('Action', 'Select', 'Open Tasking Report', taskingId);

    Navigation.openScreen(
      {
        screen: 'GroupDeployReport',
        title: I18n.ac('airforce.readinessCompletion'),
        passProps: { taskingId },
      },
      this.props.componentId,
      true
    );
  };

  handleGroupTap = (groupName) => {
    Utils.trackEvent('Action', 'Select', 'Open Group Report', groupName);

    Navigation.openScreen(
      {
        screen: 'GroupDeployReport',
        title: I18n.ac('airforce.readinessCompletion'),
        passProps: { groupName },
      },
      this.props.componentId,
      true
    );
  };

  handleAddResident = () => {
    Navigation.showModal({
      screen: 'CaseForm',
      title: I18n.ac('case.newCase'),
    });
  };

  handleModalClosed = (edited) => {
    if (edited) {
      this.setState({ toggleToRefreshSearch: !this.state.toggleToRefreshSearch });
    }
  };

  _renderHeaderNative() {
    return (
      <View style={styles.header}>
        <HeaderItem
          label={I18n.ac_aec('employer.resident')}
          name="name"
          style={NAME_STYLE}
          left={true}
        />
        <HeaderItem
          label={I18n.ac('airforce.procedures')}
          name="openProcedures"
          style={PROCEDURES_STYLE}
        />
        <HeaderItem label={I18n.ac('airforce.deploy')} name="deploy" style={DEPLOY_STYLE} />
      </View>
    );
  }
  _renderHeaderWeb() {
    return (
      <View style={styles.header}>
        <HeaderItem label={I18n.ac_aec('employer.resident')} name="name" style={NAME_STYLE} />
        <HeaderItem
          label={I18n.ac('airforce.patientType')}
          name="patientType"
          style={PATIENT_TYPE_STYLE}
        />
        <HeaderItem label={I18n.ac('airforce.rank')} name="rank" style={RANK_STYLE} />
        <HeaderItem label={I18n.ac('airforce.squadron')} name="group" style={GROUP_STYLE} />
        <HeaderItem
          label={I18n.ac('airforce.openProcedures')}
          name="openProcedures"
          style={PROCEDURES_STYLE}
        />
        <HeaderItem label={I18n.ac('airforce.deploy')} name="deploy" style={DEPLOY_STYLE} />
      </View>
    );
  }
  renderHeader = () => {
    return __WEB__ ? this._renderHeaderWeb() : this._renderHeaderNative();
  };

  render() {
    const props = this.props;
    return (
      <CaseSearchEmployer
        confirmationOpts={this.state.confirmationOpts}
        toggleToRefreshSearch={this.state.toggleToRefreshSearch}
        renderItem={this.renderItem}
        renderHeader={this.renderHeader}
        handleAddResident={this.handleAddResident}
        searchLabel={I18n.ce_aec('searchResidentsAF')}
        includeConsults={true}
      />
    );
  }
}

const styles = StyleSheet.create({
  header: {
    height: 45,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.altContrast,
    borderColor: COLOR.altAccent,
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ openCaseInfo, sendInvitations, setSelectedConsult }, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(PeopleListAirforce);
